import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";

let responsiveLength = "1000";

let useStyles = makeStyles((theme) => ({
    root: {
        ...theme.grid.gridMdContent,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        textAlign: 'center',
        margin: '100px auto',
        flexWrap: 'wrap',
        backgroundColor: '#F6F7FF',
        padding: 50,
        [theme.breakpoints.down('400')]: {
            padding: "50px 20px",
        },
    },
    line: {
        borderRadius: 3,
        height: 4,
        border: 'none',
        backgroundColor: theme.palette.light.type2,
        position: 'absolute',
        top: -10,
        width: 30,
        right: '50%',
        [theme.breakpoints.down(responsiveLength)]: {
            top: -10,
            display: 'none'
        }
    },
    desc: {
        width: '50%',
        margin: "10px auto",
        fontSize: 16,
        minWidth: 600,
        maxWidth: '100%',
        [theme.breakpoints.down('750')]: {
            minWidth: '100%',
        },

    },
    content: {
        position: 'relative'
    },
    title: {
        fontSize: 28,
    },
    gridBtns: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        margin: '50px auto',

    },
    btns: {
        width: 179,
        height: 50,
        borderRadius: 5,
        border: "none",
        fontSize: 16,
        backgroundColor: 'transparent',
        '&:hover': {
            background: "#EDEFFE",
            color: '#425BB4'
        },
        [theme.breakpoints.down('910')]: {
            minWidth: '50%',
        },
        [theme.breakpoints.down('510')]: {
            minWidth: '100%',
        },
    },
    btnActive:{
            background: "#EDEFFE",
            color: '#425BB4'
    },
    descT: {
        width: '100%',
        minHeight:30,
    },
    gridBtn: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',

        margin: '45px auto 0px auto'
    },
    btnWhite: {
        padding: '0px 33.5px',
        [theme.breakpoints.down('375')]: {
            width: '100%'
        },
    }
}))

export default function Index() {

    let classes = useStyles();
    const [state, setstate] = useState({
        1: 'در این بازار، محصولات مهم و مختلفی مانند انواع محصولات پتروشیمی، فرآورده‌های نفتی، محصولات کشاورزی و همین‌طور انواع محصولات صنعتی و معدنی دادوستد می‌شود. در این بازار، فروشنده یک قیمت برای عرضه محصول اعلام می‌کند و متقاضیان آن، باتوجه به حجم و عرضه قیمت‌های مختلفی را که برابر باقیمت فروشنده و یا بالاتر از قیمت پیشنهادی فروشنده است به او پیشنهاد می‌کنند که در مرحله آخر، محصول به بالاترین قیمت پیشنهادی فروخته می‌شود',
        2: 'محصولاتی که به دلایل مختلف ازجمله عدم تأیید کیفیت و یا عرضه نامنظم یا به هر دلیل دیگری نمی‌توانند در بازار فیزیکی حضورداشته باشند، در بازار دیگری تحت عنوان بازار فرعی دادوستد می‌شوند. محصولات این بازار نیز عبارت‌اند از محصولات پتروشیمی، کشاورزی، معدنی، پلیمر و صنعتی و ... که قابل‌عرضه در معاملات داخلی و خارجی هستند.',
        3: 'این بازار جهت جذب سرمایه‌گذاران بیشتر و فراگیر تر شدن بورس کالا تأسیس‌ شده است و شامل ۳ زیرمجموعه با نام‌های گواهی سپرده کالایی، صندوق‌ سرمایه‌گذاری کالایی و قرارداد سلف موازی استاندارد است.',
        4: 'هدف از تأسیس بازار مشتقه سازمان بورس کالا، مدیریت ریسک قیمت و بهره مندی از اهرم و هم چنین تضمین معاملات است. نحوه فعالیت این بازار این‌گونه است که یک دارایی خاص عرضه‌شده و بر روی آن، قراردادهایی تنظیم می‌شود. منظور از دارایی خاص نیز هر محصولی می‌تواند باشد.از محصولات غذایی مانند زعفران و پسته گرفته تا انواع محصولات پتروشیمی و فلزات گران‌بها قابل معرفی به‌عنوان دارایی پایه هستند',
    });

    const [indexSatet, setindexSatet] = useState(1);


    return (
        <div className={classes['root']}>
            <div className={classes['girdContent']}>
                <div className={classes['content']}>
                    <div className={classes['line']} />
                    <h3 className={classes['title']}>
                        انواع بازارها در بورس کالا
                    </h3>
                    <p className={classes['desc']}>
                        بورس کالای ایران دارای 4 بازار اصلی است که هرکدام ویژگی‌های خاصی دارند تا نیازهای مختلف فعالان بازار پوشش داده شود.به عنوان مثال در یک بازار شاهد معاملات فلزات هستیم، در یک بازار معاملات گواهی تمام سکه بهار آزادی، در بازاری دیگری شاهد معاملات مواد پتروشیمی و...
                    </p>
                </div>
                <div className={classes['gridBtns']}>
                    <button type="text" className={`${classes['btns']} ${indexSatet === 1 ?classes['btnActive'] : '' }`} onClick={()=>setindexSatet(1)}>
                        بازار فیزیکی
                    </button>
                    <button type="text" className={`${classes['btns']} ${indexSatet === 2 ?classes['btnActive'] : '' }`} onClick={()=>setindexSatet(2)}>
                        بازار فرعی
                    </button>
                    <button type="text" className={`${classes['btns']} ${indexSatet === 3 ?classes['btnActive'] : '' }`} onClick={()=>setindexSatet(3)}>
                        بازار مالی
                    </button>
                    <button type="text" className={`${classes['btns']} ${indexSatet === 4 ?classes['btnActive'] : '' }`} onClick={()=>setindexSatet(4)}>
                        بازار مشتقه
                    </button>
                </div>
                <div>
                    <p className={classes['descT']}>
                        {state[indexSatet] ? state[indexSatet] : ''}
                    </p>
                </div>
                <div className={classes['gridBtn']}>
                    <button type="text" className={`${classes['btnWhite']} btnPouyanWhite`} >
                        اطلاعات بیشتر
                    </button>
                </div>
            </div>
        </div>
    )
}
